/* eslint-disable indent */
import { useState, useEffect } from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'react-bootstrap/Table'
import loginUser from '../services/login'
import RangeSlider from './RangeSlider'
import PlayerOnTransfer from './PlayerOnTransfer'
import Spinner from 'react-bootstrap/Spinner'

const TransferSearch = () => {
  const dispatch = useDispatch()
  const [filters, setFilters] = useState({
    keeper: [0, 20],
    defending: [0, 20],
    playmaking: [0, 20],
    wing: [0, 20],
    passing: [0, 20],
    scoring: [0, 20],
    setpieces: [0, 20],
    decimal: [0, 1],
    age: { years: [17, 36], days: [0, 111] },
    price: 0,
  })
  const [filtered, setFiltered] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState(null)

  const roles = ['skoutti', 'seuraaja', 'valmentaja', 'johtaja']

  useEffect(() => {
    loginUser(dispatch)
  }, [])
  const user = useSelector(state => state.user)

  const handleFilterChange = (name, value) => {
    if (name === 'age') {
      setFilters(prevFilters => ({
        ...prevFilters,
        age: {
          ...prevFilters.age,
          ...value,
        },
      }))
    } else {
      setFilters(prevFilters => ({
        ...prevFilters,
        [name]: value,
      }))
    }
  }

  const applyFilters = async () => {
    try {
      setIsLoading(true)
      setFiltered([])
      setMessage('')
      const response = await axios.post(
        '/login/transfersearch/' + user.oauth_token,
        filters
      )
      setFiltered(response.data)
      setIsLoading(false)
    } catch (error) {
      setMessage(error.response.data.error)
      setIsLoading(false)
    }
  }
  console.log(user)

  return user && roles.includes(user.role) ? (
    <>
      <Table striped bordered variant="dark" size="sm">
        <tbody>
          <tr>
            <RangeSlider
              name="keeper"
              value={filters.keeper}
              onChange={value => handleFilterChange('keeper', value)}
            />
            <RangeSlider
              name="defending"
              value={filters.defending}
              onChange={value => handleFilterChange('defending', value)}
            />
          </tr>
          <tr>
            <RangeSlider
              name="playmaking"
              value={filters.playmaking}
              onChange={value => handleFilterChange('playmaking', value)}
            />
            <RangeSlider
              name="wing"
              value={filters.wing}
              onChange={value => handleFilterChange('wing', value)}
            />
          </tr>
          <tr>
            <RangeSlider
              name="passing"
              value={filters.passing}
              onChange={value => handleFilterChange('passing', value)}
            />
            <RangeSlider
              name="scoring"
              value={filters.scoring}
              onChange={value => handleFilterChange('scoring', value)}
            />
          </tr>
          <tr>
            <RangeSlider
              name="setpieces"
              value={filters.setpieces}
              onChange={value => handleFilterChange('setpieces', value)}
            />
            <RangeSlider
              name="decimal"
              value={filters.decimal}
              onChange={value => handleFilterChange('decimal', value)}
              min={0}
              max={1}
              step={0.05}
            />
          </tr>
          <tr>
            <RangeSlider
              name="years"
              value={filters.age.years}
              onChange={value => handleFilterChange('age', { years: value })}
              min={17}
              max={36}
            />
            <RangeSlider
              name="days"
              value={filters.age.days}
              onChange={value => handleFilterChange('age', { days: value })}
              min={0}
              max={111}
            />
          </tr>
          <tr>
            <td>
              <input
                id="priceFilter"
                type="number"
                value={filters.price}
                onChange={e =>
                  handleFilterChange('price', Number(e.target.value))
                }
                min={0}
                placeholder="0"
                style={{ width: '100%' }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <button onClick={applyFilters}>Filter</button>
            </td>
          </tr>
        </tbody>
      </Table>
      <Table striped bordered hover variant="dark" size="sm">
        <thead>
          <tr>
            <td>Nimi</td>
            <td>Alataso</td>
            <td>Hinta</td>
            <td>Ikä</td>
            <td>Spessu</td>
            <td>Maalivahti</td>
            <td>Puolustus</td>
            <td>Pelinrakennus</td>
            <td>Laituri</td>
            <td>Syöttäminen</td>
            <td>Maalinteko</td>
            <td>Erikoistilanteet</td>
          </tr>
        </thead>
        <tbody>
          {isLoading ? <Spinner animation="border"></Spinner> : <></>}
          {filtered.length > 0 ? (
            filtered.map(player => (
              <PlayerOnTransfer key={player.playerId} player={player} />
            ))
          ) : message ? (
            <td>{message}</td>
          ) : (
            <></>
          )}
        </tbody>
      </Table>
    </>
  ) : (
    <></>
  )
}

export default TransferSearch
